import { createSlice } from "@reduxjs/toolkit";

const localSlice = createSlice({
  name: "local",
  initialState: {},
  reducers: {
    updateLocal: (state, action) => {
      return { ...state, ...action.payload };
    },
  },
});

export const { updateLocal } = localSlice.actions;
export default localSlice.reducer;
